import {
  PLAN_OLD_FREE,
  PLAN_NEW_FREE,
  PLAN_OLD_PRO,
  PLAN_OLD_ULTIMATE,
  PLAN_SMALL_BUSINESS,
  PLAN_EXTENSION_ADDON,
  PLAN_ENTERPRISE,
} from '../../constants';
import GiftBoxIcon from '../../../assets/icons/gift_box.svg';
import BirdIcon from '../../../assets/icons/bird.svg';
import TieIcon from '../../../assets/icons/tie.svg';
import PlugIcon from '../../../assets/icons/plug.svg';

export const PLANS = [
  {
    planId: PLAN_OLD_FREE.toString(),
    planName: 'Current Plan',
    recommended: false,
    currency: '$',
    price: '0',
    sub_interval: 'Month',
    icon: TieIcon,
    included: '',
    key_features: [
      '50+ types Whatsapp Widget and buttons',
      'Multiple whatsapp numbers and time of chat availability',
    ],
    catch_line: '',
  },
  {
    planId: PLAN_OLD_PRO.toString(),
    planName: 'Pro',
    recommended: false,
    currency: '$',
    price: '7.99',
    sub_interval: 'Month',
    icon: TieIcon,
    included: '',
    key_features: [
      '50+ types Whatsapp Widget and buttons',
      'Multiple whatsapp numbers and time of chat availablity.',
      'Analytics Dashboard',
      'WhatsApp Customer Support Tool',
    ],
    catch_line: '',
  },
  {
    planId: PLAN_OLD_ULTIMATE.toString(),
    planName: 'Ultimate',
    recommended: false,
    currency: '$',
    price: '9.99',
    sub_interval: 'Month',
    icon: TieIcon,
    included: 'Everything in Free, plus:',
    key_features: [
      'Private whatsapp number',
      'Whatsapp Business Account setup with Green Tick',
      'WhatsApp Customer Support Tool',
    ],
    catch_line: '',
  },
  {
    planId: PLAN_NEW_FREE.toString(),
    planName: 'Free',
    recommended: false,
    currency: '$',
    price: '0',
    additionalCharges: '+ Usage Based Charge',
    sub_interval: 'Month',
    icon: GiftBoxIcon,
    included: '',
    key_features: [
      '50+ types Whatsapp Widget and buttons',
      'Multiple whatsapp numbers and time of chat availability',
      'Analytics Dashboard',
      'Automated Whatsapp messages (Enabled by Default)',
      'Pre approved templates',
      'Order Confirmation, Order Shipment and Abandoned Cart Recovery',
    ],
    catch_line: '',
    note: 'Note: Per message charges for free plan users can be found in <a target="_blank" href="https://docs.google.com/spreadsheets/u/2/d/1GX6yTDK8imK0YuOFCkU-Lpa3nCFifuq_oaujFvQaiCE/edit?usp=sharing" rel="noopener noreferrer">pricing chart</a>'
  },
  {
    planId: PLAN_SMALL_BUSINESS.toString(),
    planName: 'Growth',
    recommended: false,
    currency: '$',
    price: '15',
    sub_interval: 'Month',
    icon: BirdIcon,
    included: 'Everything in Free, plus:',
    key_features: [
      'Private whatsapp number',
      'Whatsapp Business Account setup with Green Tick',
      'Create your own templates',
      'Marketing campaigns',
      'Advanced analytics',
      'WhatsApp Customer Support Tool',
    ],
    catch_line: '1000 Free messages/month from Whatsapp',
    note: 'Note: Per Message Charges for growth plan users = <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/16bLV9hMmFuBpplv55WWXCpjFoMG0xA78oghN2iEdmao/edit?usp=sharing">WA Charges</a> + $ 0.004'
  },
  {
    planId: PLAN_ENTERPRISE.toString(),
    planName: 'Engage',
    recommended: false,
    currency: '$',
    price: '25',
    sub_interval: 'Month',
    icon: TieIcon,
    included: 'Everything in Growth, plus:',
    key_features: [
      'Shared team inbox for your Whatsapp Business Account',
      'Dashboard with unlimited agents',
      'Tag, assign & reply to Whatsapp chats',
      'Setup auto reply & quick reply messages',
      'Detailed reporting of support conversations',
      'Round-robin allocation of incoming customer conversations',
    ],
    catch_line: '',
    note: 'Note: Per Message Charges for engage plan users = <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/16bLV9hMmFuBpplv55WWXCpjFoMG0xA78oghN2iEdmao/edit?usp=sharing">WA Charges</a> + $ 0.004'
  },
];

export const EXTENSION_ONLY_PLAN = {
  planId: PLAN_EXTENSION_ADDON,
  planName1: 'Whatsapp Support Tool',
  planName2: 'Extension',
  currency: '$',
  price: '7.99',
  sub_interval: 'Month',
  icon: PlugIcon,
  included: '',
  key_features: ['Everything in Free + Manual Whatsapp Customer Support Tool'],
  catch_line: '',
};

export const recommendedPlans = {
  [PLAN_OLD_FREE.toString()]: [
    PLANS[3],
    {
      ...PLANS[4],
      recommended: true,
    },
    PLANS[5],
  ],
  [PLAN_OLD_PRO.toString()]: [
    PLANS[3],
    {
      ...PLANS[4],
      recommended: true,
    },
    PLANS[1],
  ],
  [PLAN_OLD_ULTIMATE.toString()]: [
    PLANS[3],
    {
      ...PLANS[4],
      recommended: true,
    },
    PLANS[2],
  ],
  [PLAN_NEW_FREE.toString()]: [
    PLANS[3],
    {
      ...PLANS[4],
      recommended: true,
    },
    PLANS[5],
  ],
  [PLAN_SMALL_BUSINESS.toString()]: [
    PLANS[3],
    PLANS[4],
    {
      ...PLANS[5],
      recommended: true,
    },
  ],
  [PLAN_ENTERPRISE.toString()]: [
    PLANS[3],
    PLANS[4],
    {
      ...PLANS[5],
      recommended: true,
    },
  ],
};

export const TILE = 10 ;

export const planStatusDetails = {
  [PLAN_OLD_FREE] : {
                      name : "Old FREE",
                      color : 0,
                      description1 : "Upgrade to new", 
                      nextPlan : " Free Plan", 
                      nextPlanId : PLAN_NEW_FREE,
                      description2 : " to get access to automated templates and abandoned cart notifications",
                      premium : false 
                  },
  [PLAN_OLD_PRO] :  {
                      name : "Old PRO",
                      color : 0,
                      description1 : "Upgrade to",
                      nextPlan: " Growth Plan",
                      nextPlanId : PLAN_SMALL_BUSINESS, 
                      description2 : " to get your branded Whatsapp Business Account, customized campaigns and more",
                      premium : false 
                  },
[PLAN_OLD_ULTIMATE] : {
                      name : "Old ULTIMATE",
                      color : 0,
                      description1 : "Upgrade to",
                      nextPlan : " Growth Plan",
                      nextPlanId : PLAN_SMALL_BUSINESS,
                      description2 : " to create customized templates and launch marketing campaigns",
                      premium : false 
                  },
  [PLAN_NEW_FREE] : {
                      name : "FREE",
                      color : 1,
                      description1 : "Use our chat and share widgets and enable automated messages on Whatsapp",
                      nextPlanId: PLAN_SMALL_BUSINESS,
                      premium : false 
                  },
[PLAN_SMALL_BUSINESS] : {
                      name : "GROWTH",
                      color : 1,
                      description1 : "You are all set to run marketing campaigns, create custom templates and send automated & manual notifications.",
                      nextPlanId : PLAN_ENTERPRISE,
                      premium : true
                  },
[PLAN_ENTERPRISE] : {
                    name : "ENGAGE",
                    color : 1,
                    description1 : "You are all set to use shared team inbox. You can also run marketing campaigns, create custom templates and send automated & manual notifications.",
                    nextPlanId : PLAN_ENTERPRISE,
                    premium : true
                  },
            [TILE]  : {
                    name : "Old ULTIMATE",
                    color : 0,
                    description1 : "Upgrade to",
                    nextPlan : " Growth Plan",
                    nextPlanId : PLAN_SMALL_BUSINESS,
                    description2 : " to create customized templates and launch marketing campaigns",
                    premium : false 
                  }
}
